import { IbgeUF, useGetIbgeUFQuery } from "@/store";

type UseGetStatesParams<T> = {
  getLabelByKey?: (uf: T) => string;
  getValueByKey?: (uf: T) => string;
};
export function useGetStates<T extends IbgeUF>(options?: UseGetStatesParams<T>) {
  const { data, ...state } = useGetIbgeUFQuery(undefined, {
    selectFromResult: (state) => {
      return {
        ...state,
        data: {
          options:
            state.data?.map((uf) => ({
              label: options?.getLabelByKey ? options.getLabelByKey(uf as T) : uf.nome,
              value: options?.getValueByKey ? options.getValueByKey(uf as T) : uf.sigla
            })) ?? [],
          data: state.data ?? []
        }
      };
    }
  });

  return {
    ...state,
    data: {
      result: data?.data,
      options: data?.options
    }
  };
}
